import React, { Component, ErrorInfo } from 'react'
import { Alert, Button } from 'react-bootstrap'

interface Props {
    children: React.ReactNode
}

interface State {
    error: Error | null
}

class ErrorBoundary extends Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = { error: null }
    }

    static getDerivedStateFromError(error: Error): State {
        return { error }
    }

    componentDidCatch(error: Error, info: ErrorInfo): void {
        console.error('ErrorBoundary caught:', error, info.componentStack)
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{ padding: '2rem' }}>
                    <Alert variant="danger">
                        <Alert.Heading>Something went wrong</Alert.Heading>
                        <p>{this.state.error.message}</p>
                        <Button variant="outline-danger" onClick={() => this.setState({ error: null })}>
                            Try again
                        </Button>
                    </Alert>
                </div>
            )
        }
        return this.props.children
    }
}

export default ErrorBoundary
